import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import userSocialLogin from '../api/graphql/mutations/userSocialLogin';
import { useAuth } from '../utils/AuthProvider';

const CLIENT_ID = '374001476805-jdr4d87slvoaobdajc0bas161r661rfs.apps.googleusercontent.com'; // NOTE: should better come from the env vars
const SCRIPT_ID = 'gapi_auth_lib';
const ERROR_INVALID_USER = 'INVALID USER';

const responseGoogle = async (payload) => {
  const result = await userSocialLogin(payload).then((response) => {
    if (response.token) return (response.token);
    console.log('**** User Not Valid by Server, Sorry ****', response.error);
    return undefined;
    // TODO: if the user does'nt exists we will show a message to prom register
  }).catch((err) => {
    console.log('Some error happened on fetch of fetchPostDescription:', err);
  });

  return result;
};

const removeGoogleSSOScript = () => {
  const gscript = document.getElementById(SCRIPT_ID);
  document.body.removeChild(gscript);
};

const GoogleSSO = () => {
  const history = useHistory();
  const [error, setError] = useState(false);
  const { setToken } = useAuth();

  const getGoogleAuth = async (auth) => {
    const { credential } = auth;
    if (!credential) return;
    const token = await responseGoogle({ tokenId: credential });
    const isAdminUser = setToken(token);
    if (!isAdminUser) setError(true);
    else history.push('/cms');
  };

  const loadGoogleSSOScript = () => new Promise((res, rej) => {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.type = 'text/javascript';
    script.src = 'https://accounts.google.com/gsi/client';
    script.id = SCRIPT_ID;

    document.body.appendChild(script);

    script.onerror = (err) => {
      rej(Error(`Error loading Google SSO script: ${JSON.stringify(err, null, 2)}`));
    };

    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: getGoogleAuth,
      });
      window.google.accounts.id.renderButton(
        document.getElementById('google_login_button'),
        { theme: 'filled_black', size: 'large', shape: 'circle', type: 'standard' }, // customization attributes
      );
    };
  });

  useEffect(() => {
    loadGoogleSSOScript();
    return () => removeGoogleSSOScript();
  }, []);
  return (
    <div>
      <div id="google_login_button" />
      { error ? <p className="flex flex-col text-red mt-4 font-americaMonoRegular">{ERROR_INVALID_USER}</p> : null }
    </div>
  );
};

export default GoogleSSO;
